import { useDispatch, useSelector } from 'react-redux';
import { useEffectOnce } from 'usehooks-ts';

import { useParseParams } from '@hooks/params';
import { compareHealthQuoteParamsSchema } from '@apis/HealthQuoteApi';

import { selectHealthQuoteComparePage } from './selector';
import { healthQuotesFetch, HealthQuotesFetchPayload } from './action';
import { HealthQuoteComparePageParams } from './route';

export const useHealthQuotesComparePageParams = () =>
  useParseParams<HealthQuoteComparePageParams>(compareHealthQuoteParamsSchema);

export const useHealthQuotesFetch = () => {
  const dispatch = useDispatch();
  const payload: HealthQuotesFetchPayload = useHealthQuotesComparePageParams();
  const { healthQuotes } = useSelector(selectHealthQuoteComparePage);

  useEffectOnce(() => {
    dispatch(healthQuotesFetch(payload));
  });

  return healthQuotes;
};
